import React from 'react'
import { NUM_CATEGORIES } from '@mc/constants'
import { Trans, useTranslation } from '@mc/i18n'
import { getNumberOfInstructors } from '@mc/instructors'
import { Header, HeaderContent } from '@mc/plans-ui'
import { CHECKOUT_I18N_NAMESPACE } from '../../../../i18n'

export const GiftHeader = () => {
  const { t } = useTranslation(CHECKOUT_I18N_NAMESPACE)

  return (
    <Header>
      <HeaderContent.MainTitle
        title={t('plans.titleGift')}
        subtitle={
          <Trans i18nKey='plans.subtitle' ns={CHECKOUT_I18N_NAMESPACE}>
            <span className='mc-text--bold' />
          </Trans>
        }
      />
      <HeaderContent.ValueProps
        items={[
          t('plans.valueProps.item1', {
            instructors: getNumberOfInstructors(),
            categories: NUM_CATEGORIES,
          }),
          t('plans.valueProps.item2'),
        ]}
      />
    </Header>
  )
}
